export function updateProducts(state, { products }) {
  state.products = products;
}
